import React, { useCallback, useState } from "react";
import { Option } from "@fluentui/react-components";
import { observer } from "mobx-react";

import { useFeedbackStyle } from "./UserFeedback.styles";
import { FeedbackCategoryOptionProps } from "./UserFeedback.types";

const FeedbackCategoryOptionBase = ({ category, icon: Icon, label }: FeedbackCategoryOptionProps) => {
    const classes = useFeedbackStyle();
    const [isHovered, setIsHovered] = useState(false);

    const showFilledIcon = useCallback(() => setIsHovered(true), []);
    const showRegularIcon = useCallback(() => setIsHovered(false), []);

    return (
        <Option value={category} text={label} onMouseEnter={showFilledIcon} onMouseLeave={showRegularIcon}>
            <span className={classes.categoryOption}>
                <Icon filled={isHovered} />
                {label}
            </span>
        </Option>
    );
};

export const FeedbackCategoryOption = observer(FeedbackCategoryOptionBase);
